import { initialState } from "./reducer_constant";
import * as actionTypes from './action_types';

function appReducer(state = initialState, { type, payload }: any) {
    switch (type) {
        case actionTypes.UPDATE_PERSONAL_FORM:
            return {
                ...state,
                personal_form: {
                    ...state.personal_form,
                    [payload.key]: payload.value,
                },
            };
        case actionTypes.UPDATE_FORM:
            return {
                ...state,
                form: {
                    ...state.form,
                    [payload.key]: payload.value,
                },
            };
        case actionTypes.START:
            return {
                ...state,
                started: true,
            };
        case actionTypes.CHECK_ONBORDING:
            return {
                ...state,
                onboarding_viewed: true,
            };
        case actionTypes.SET_PRIOR_TREATMENT:
            return {
                ...state,
                prior_treatment: payload,
            };
        case actionTypes.SET_SUICIDE_ATTEMPT:
            return {
                ...state,
                suicide_attempt: payload,
            };
        case actionTypes.SET_SUICIDE_ATTEMPT_WHEN:
            return {
                ...state,
                suicide_attempt_when: payload,
            };
        case actionTypes.RESET:
            return {
                ...initialState,
            };
        default:
            return state;
    }
}

export default appReducer;